<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pii.details.failedWarning.title' | translate }}
    </p>
    <button
      ngbAutoFocus
      class="btn btn-link text-body p-0 ms-auto cursor-pointer"
      (click)="modalRef.close()"
    >
      <i class="fa-light fa-xmark"></i>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ 'pii.details.failedWarning.message' | translate }}</p>
    <p>{{ 'pii.details.failedWarning.reviewMessage' | translate }}</p>
    @if (dataTableConfiguration) {
      <app-data-table [configuration]="dataTableConfiguration"></app-data-table>
    }
  </div>
</div>
